import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { useMemo } from "react";
import { CustomButton } from "@/src/lib/ui";
import {
    updateTestDetails,
    updateCurrentStep,
    appointmentSteps,
} from "@/src/lib/store/pet-ct-appointment-new/slice";
import { useDispatch } from "react-redux";
import Skeleton from "@/src/components/common/Skeleton";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Iconify from "@/src/components/iconify";

const SelectAppointment = () => {
    const dispatch = useDispatch();
    const { query } = useRouter();
    const { data: petCTItemList, isLoading: isLoadingPetCtItemList } =
        useCustomQuery(["get_pet_ct_item_list"], () =>
            cartApiService.getPetCTItemList()
        );
    const items = useMemo(
        () => petCTItemList?.data || [],
        [petCTItemList?.data]
    );

    const handleSelect = (item) => {
        console.log(item, "item");
        if (!!item.itemId) {
            dispatch(updateTestDetails(item));
            dispatch(updateCurrentStep(appointmentSteps.SELECT_CENTRE));
        }
    };

    useEffect(() => {
        if (query?.itemId) {
            const item = items.find(
                (item) => item.itemId === Number(query?.itemId)
            );
            if (item) {
                handleSelect(item);
            }
        }
    }, [query?.itemId, items]);

    return (
        <div className="shadow-md bg-white">
            {isLoadingPetCtItemList ? (
                <>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <div
                            className="border-b border-gray-300 md:p-8 p-3 flex flex-row justify-between items-center last:border-b-0 group transition-all duration-300 cursor-pointer"
                            key={i}
                        >
                            <div className="flex-1 w-full max-w-[450px]">
                                <Skeleton
                                    variant="rounded"
                                    height="20px"
                                    width="100%"
                                    className="flex"
                                />
                            </div>
                            <div className="w-16 md:w-20 ml-4">
                                <Skeleton
                                    variant="text"
                                    height="36px"
                                    width="100%"
                                    className="flex"
                                />
                            </div>
                        </div>
                    ))}
                </>
            ) : (
                items.map((item) => (
                    <div
                        onClick={() => handleSelect(item)}
                        className="border-b border-gray-300 md:gap-8 gap-4 md:p-8 p-3 flex flex-row justify-between items-center last:border-b-0 group transition-all duration-300 cursor-pointer"
                        key={item.itemId}
                    >
                        <div className="flex items-center gap-4">
                            <div className="md:w-12 md:h-12 w-8 h-8 shrink-0 flex items-center justify-center border border-primary/50 rounded-full group-hover:bg-primary/10 transition-all duration-300">
                                <Iconify
                                    icon={item.icon}
                                    className="text-primary md:w-8 md:h-8 w-6 h-6"
                                />
                            </div>
                            <div>
                                <div className="font-semibold tracking-wide text-sm md:text-base">
                                    {item.scanName}
                                </div>
                                <p className="md:text-sm text-xs text-gray-500">
                                    {item.shortDescription}
                                </p>
                            </div>
                        </div>
                        <CustomButton
                            className="bg-gray-700 text-white !text-xs rounded-none font-normal group-hover:bg-primary transition-all duration-300 uppercase px-2 md:py-2.5 py-1.5 tracking-wider"
                        >
                            Select
                        </CustomButton>
                    </div>
                ))
            )}
        </div>
    );
};

export default SelectAppointment;
